export default function WaitComponent({ Items, style, Caption = null}) {
	return (
		<div className={"center-child"}><div className={"lds-roller"}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>
	)
}
	
